import { AutenticacionService } from './autenticacion.service';
import { ConstantsService } from './constants.service';
import { Http, ResponseContentType, URLSearchParams } from '@angular/http';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';


@Injectable()
export class ReporteLiquidacionService {
  private service_url: string;
  private api_url: string;
  private modulo_url: string;
  constructor(private http: Http, private constantsService: ConstantsService, private authService: AutenticacionService) {
    this.api_url = this.constantsService.apiURL;
    this.modulo_url = '/liquidacion/revision/reportes';
    this.service_url = this.api_url + this.modulo_url;
  }

  public getDefaultSchedule() {
    return {
      'sendEmail': 0,
    };
  }

  public getDefaultScheduleInversionistas() {
    return {
      "obras": {},
      "liquidacion": {},
      "resultados": {},
      "generacion": "",
      "notasAdministracion": "null",
      "retornosHistoricos": [],
      "cobranza": "",
      "variacion": "",
      "fondoAhorro": {},
      "ingresos": [],
      "egresos": [],
      "imagenes": [],
      "reporteRentabilidad": {
        "tabla": [],
        "total": ""
      },
      "puntoEquilibrio": "",
      "comentariosFinales": ""
    };
  }

  getReporte(reporteID) {
    return this.http.get(this.service_url + '?idLiquidacion=' + reporteID, this.authService.getAuthHeaders());
  }

  getLiquidacionesList() {
    return this.http.get(this.service_url + '/select', this.authService.getAuthHeaders());
  }

  getReporteInversionista(inversionistaID) {
    return this.http.get(this.service_url + '/inversionistas?idLiquidacion_Reporte_Inversionistas=' + inversionistaID, this.authService.getAuthHeaders());
  }
  getReporteInversionistaGrupo(grupoId) {
    return this.http.get(this.service_url + '/inversionistas?idLiquidacion_Reporte_Grupo_Elemento=' + grupoId, this.authService.getAuthHeaders());
  }

  getReporteImagen(idImagen) {
    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;
    return this.http.get(this.api_url + '/liquidacion/revision/imagen?id=' + idImagen, options);
  }

  saveReporte(data) {
    return this.http.put(this.service_url, data, this.authService.getAuthHeaders());
  }

  getInversionistas(idLiquidacion) {
    return this.http.get(this.service_url + '/select/inversionistas?idLiquidacion=' + idLiquidacion, this.authService.getAuthHeaders());
  }

  SaveLiquidacionComprobanteImagen(file, idLiquidacion_Reporte, idLiquidacion_Reporte_Inversionistas) {
    const formData = new FormData();
    formData.append('idLiquidacion_Reporte', idLiquidacion_Reporte);
    formData.append('imagen', file);
    formData.append('idLiquidacion_Reporte_Inversionistas', idLiquidacion_Reporte_Inversionistas);
    return this.http.post(this.service_url + '/comprobantes', formData, this.authService.getAuthHeaders());
  }



  SaveLiquidacionComprobanteImagenElement(file, idLiquidacion_Reporte, idLiquidacion_Reporte_Grupo_Elemento) {
    const formData = new FormData();
    formData.append('idLiquidacion_Reporte', idLiquidacion_Reporte);
    formData.append('imagen', file);
    formData.append('idLiquidacion_Reporte_Grupo_Elemento', idLiquidacion_Reporte_Grupo_Elemento);
    return this.http.post(this.service_url + '/comprobantes', formData, this.authService.getAuthHeaders());
  }

  public DeleteLiquidacionImagenComprobante(idLiquidacion_Reporte, idLiquidacion_Comprobantes) {
    return this.http.delete(this.service_url + '/comprobantes?idLiquidacion_Reporte=' + idLiquidacion_Reporte + '&idLiquidacion_Comprobantes=' + idLiquidacion_Comprobantes, this.authService.getAuthHeaders());
  }

  public sendLiquidacion(idLiquidacion) {
    const data = {
      'idLiquidacion_Reporte': idLiquidacion
    };
    return this.http.put(this.service_url + '/send', data, this.authService.getAuthHeaders());
  }

  public calculateRetention(mode = 0, amount, rentaConIva, porcentaje) {
    if (mode == 0) { //SC
      return this.calculateRetentionSC(amount);
    } else if (mode == 1) { //Fideicomiso
      return this.calculateRetentionFideicomiso(rentaConIva, porcentaje);
    }
  }

  public calculateRetentionSC(amount) {

    //S.C. calcular como isr

    //Actualización con la tabla del 2021
    // var retentionTable = [
    //   //limite inferior, base, porcentaje sobre excedente.
    //   [375975.62, 117912.32, 35], //[0]
    //   [125325.21, 32691.18, 34], //[1]
    //   [93993.91, 22665.17, 32], //[2]
    //   [49233.01, 9236.89, 30], //[3]
    //   [31236.50, 5004.12, 23.52], //[4]
    //   [15487.72, 1640.18, 21.36], //[5]
    //   [12935.83, 1182.88, 17.92], //[6]
    //   [11128.02, 893.63, 16], //[7]
    //   [6332.06, 371.83, 10.88], //[8]
    //   [746.05, 14.32, 6.40], //[9]
    //   [0.01, 0.0, 1.92], //[10]
    // ];

    //Actualización con la tabla del 2026
    var retentionTable = [
      //limite inferior, base, porcentaje sobre excedente.
      [425641.99, 133488.54, 35], //[0]
      [141880.67, 37009.69, 34], //[1]
      [106410.50, 25659.23, 32], //[2]
      [55736.68, 10457.09, 30], //[3]
      [35362.83, 5665.16, 23.52], //[4]
      [17533.64, 1856.85, 21.36], //[5]
      [14644.64, 1339.14, 17.92], //[6]
      [12598.02, 1011.68, 16], //[7]
      [7168.51, 420.95, 10.88], //[8]
      [844.59, 16.22, 6.40], //[9]
      [0.01, 0.0, 1.92], //[10]
    ];

    var baseRetention = 0.0;
    var variableRetention = 0.0;
    for (var index = 0; index < retentionTable.length; index++) {
      if (amount >= retentionTable[index][0]) {
        baseRetention = retentionTable[index][1];
        variableRetention = ((amount - retentionTable[index][0]) * retentionTable[index][2]) / 100;
        break;
      }
    }

    let result = baseRetention + variableRetention;
    return Math.round((result + Number.EPSILON) * 100) / 100;

  }

  public calculateRetentionFideicomiso(rentaConIva, porcentaje) {

    //Fideicomiso, se retienen el 10% de la renta sin IVA
    let result = ((rentaConIva / 1.16) * 0.10) * porcentaje;
    let finalValue = Math.round((result + Number.EPSILON) * 100) / 100;
    return finalValue;
  }

  //DMG services
  public uploadComprobanteLiquidacion(file, parametersJSON) {
    const formData = new FormData();
    formData.append('imagen', file);

    if (parametersJSON.idLiquidacion_Reporte_Inversionistas) {
      formData.append('idLiquidacion_Reporte_Inversionistas', parametersJSON.idLiquidacion_Reporte_Inversionistas);
    }

    if (parametersJSON.idLiquidacion_Reporte_Grupo_Elemento) {
      formData.append('idLiquidacion_Reporte_Grupo_Elemento', parametersJSON.idLiquidacion_Reporte_Grupo_Elemento);
    }

    return this.http.post(this.api_url + '/liquidacion/revision/comprobantes/save', formData, this.authService.getAuthHeaders());
  }

  public getComprobantesLiquidacion(filters: any) {
    let myParams = new URLSearchParams();

    if (filters.idLiquidacion_Reporte_Grupo_Elemento) {
      myParams.append('idLiquidacion_Reporte_Grupo_Elemento', filters.idLiquidacion_Reporte_Grupo_Elemento);
    }

    if (filters.idLiquidacion_Reporte_Inversionistas) {
      myParams.append('idLiquidacion_Reporte_Inversionistas', filters.idLiquidacion_Reporte_Inversionistas);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;

    let serviceUrl = this.api_url + '/liquidacion/revision/comprobantes';

    return this.http.get(serviceUrl, myoptions);
  }

  public deleteComprobanteLiquidacion(idComprobante: any) {
    let myoptions = this.authService.getAuthHeaders();

    let serviceUrl = this.api_url + `/liquidacion/revision/comprobantes/${idComprobante}`;

    return this.http.delete(serviceUrl, myoptions);
  }

  public getComprobateFile(idComprobante: number) {
    let myParams = new URLSearchParams();
    myParams.append('action', 'download');

    const options = this.authService.getAuthHeaders();
    options.params = myParams;
    options.responseType = ResponseContentType.Blob;

    let serviceUrl = this.api_url + `/liquidacion/revision/comprobantes/download/${idComprobante}`;
    return this.http.get(serviceUrl, options);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/reporte-liquidacion.service.ts